// extracted by mini-css-extract-plugin
export default {"imageWrapper":"EI-z","hovered":"FI-z","hoverImage":"GI-z","mainImage":"HI-z","imageNoBackground":"II-z","fullSizeImage":"JI-z"};